/* tslint:disable */

declare var Object: any;
export interface ViewActivityReportInterface {
  "empId": string;
  "companyId": number;
  "fullName"?: string;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "taskDesc"?: string;
  "timeLocation"?: string;
  "dateLocation"?: string;
  "location"?: string;
}

export class ViewActivityReport implements ViewActivityReportInterface {
  "empId": string;
  "companyId": number;
  "fullName": string;
  "posNameEn": string;
  "posNameId": string;
  "posNameMy": string;
  "posNameTh": string;
  "taskDesc": string;
  "timeLocation": string;
  "dateLocation": string;
  "location": string;
  constructor(data?: ViewActivityReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewActivityReport`.
   */
  public static getModelName() {
    return "ViewActivityReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewActivityReport for dynamic purposes.
  **/
  public static factory(data: ViewActivityReportInterface): ViewActivityReport{
    return new ViewActivityReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewActivityReport',
      plural: 'ViewActivityReports',
      path: 'ViewActivityReports',
      idName: 'empId',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "posNameId": {
          name: 'posNameId',
          type: 'string'
        },
        "posNameMy": {
          name: 'posNameMy',
          type: 'string'
        },
        "posNameTh": {
          name: 'posNameTh',
          type: 'string'
        },
        "taskDesc": {
          name: 'taskDesc',
          type: 'string'
        },
        "timeLocation": {
          name: 'timeLocation',
          type: 'string'
        },
        "dateLocation": {
          name: 'dateLocation',
          type: 'string'
        },
        "location": {
          name: 'location',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewActivityReport.ts